import FieldDefs from './TopkeysFieldDefs'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.topkeys", FieldDefs),
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
